export enum TransactionSign {
  plus = "+",
  minus = "-",
}
